import { render, staticRenderFns } from "./BrandCard.vue?vue&type=template&id=bf2a0c24&scoped=true&"
import script from "./BrandCard.vue?vue&type=script&lang=js&"
export * from "./BrandCard.vue?vue&type=script&lang=js&"
import style0 from "./BrandCard.vue?vue&type=style&index=0&id=bf2a0c24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2a0c24",
  null
  
)

export default component.exports